import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Col,
  PageHeader,
  Row,
  Spin,
  message,
  Select,
  Tag,
  Tooltip,
  Space,
  Input,
  Button
} from "antd";
import {
  ButtonItem,
  Form,
  InputNumberItem,
  SelectItem,
  TextAreaItem,
  FormItem,
  ErrorItem,
  DatePickerItem,
  SelectInsumosItem,
  SwitchItem,
  round2Decimals,
  dineroDisabledMask,
  DisponibilidadInsumoModal
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import { ArrowUpOutlined, CarOutlined, EnvironmentOutlined, FireOutlined, InfoCircleOutlined, PlusOutlined, WarningOutlined, SearchOutlined,CommentOutlined,DeleteOutlined, UserOutlined } from "@ant-design/icons";
import axios from "axios";
import VerRequisicionPdf from "./VerRequisicionPdf/VerRequisicionPdf";
import moment from "moment";
import AsignarProveedor from "../AsignarProveedor/AsignarProveedor";
import ModalVerRequisicion from "../ModalVerRequisicion/ModalVerRequisicion";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import ModalAgregarInsumoRequisicion from "../ModalAgregarInsumoRequisicion/ModalAgregarInsumoRequisicion";
import debounce from "lodash.debounce";

const { Option } = Select;

// Días de la semana para separar cantidades
const DIAS_SEMANA = [
  { key: "viernes",   label: "Vie" },
  { key: "sabado",    label: "Sáb" },
  { key: "domingo",   label: "Dom" },
  { key: "lunes",     label: "Lun" },
  { key: "martes",    label: "Mar" },
  { key: "miercoles", label: "Mié" },
  { key: "jueves",    label: "Jue" },
];

class EditarRequisicion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    todasProveedores: null,
    objetoProveedoresPInsumos: [],
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: null,
    todasInsumos: [],
    impuestos: [],
    numeroRequisicion: 0,
    presupuestoPU: false,
    presupuestoPUId: null,
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    modalVerPdf: false,
    modalVerPdfId: null,
    modalAsignarProveedor: false,
    modalAsignarProveedorInsumoId: null,
    todosUsuarios: [],
    objetoUsuarios: null,
    proyectoId: null,
    requisicionesAdicionales: [],
    workbench: this.props?.location?.state?.workbench || false,
    modalObservaciones: false,
    modalObservacionesObservaciones: null,
    modalObservacionesObservacionesPasadas: null,
    modalObservacionesObservacionesXml: false,
    mostrarCostosRequisicion: false,
    // Configuración global de la empresa: habilita el switch
    separarDiasRequisicion: false,
    // Switch por requisición: se inicializa desde los datos cargados
    separarDiasActivo: false,
    // Para la barra de busqueda 
    busquedaInsumo: "",
    insumoResaltado: null,
    autoGuardarActivo : false,
    proveedorIdActual: null,
    nombreProveedorActual: null,
    modalCrearInsumo: false,
    agregarInsumosRequisicion: false,
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '', proyectoId: null },
  };

    componentDidMount() {
    this.consultarTodo();
  }

  componentWillUnmount() {
    this.recalcularPendientes.cancel();
  }

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  abrirModalVerPdf() {
    this.setState({ modalVerPdf: true, modalVerPdfId: this.props.location.state.id });
  }

  cerrarModalVerPdf() {
    this.setState({ modalVerPdf: false, modalVerPdfId: null });
  }

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo() {
    this.setState({ loading: true });
    const responseProveedores = axios.post(
      "proveedores/selectProveedoresConTipoDeProveedor",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const responseProyectos = axios.post(
      "proyectos/selectProyectos",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const responseConfiguracionRequisiciones = axios.post(
      "requisiciones/configuracionRequisiciones",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    axios.post(
      "usuarios/selectUsuariosEmpresa",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    ).then(res => {
      if (res.data.status === 404) return [];
      this.setState({
        todosUsuarios: res.data,
        objetoUsuarios: res.data.map((value) => (
          <Option value={value._id} key={value._id}>
            {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
          </Option>
        ))
      });
    });

    const responses = await Promise.all([
      responseProveedores,
      responseProyectos,
      responseConfiguracionRequisiciones
    ]);

    let newState = {};

    if (responses[0].data.status !== 404) {
      newState.todasProveedores = responses[0].data;
      newState.objetoProveedores = responses[0].data.map((value) => (
        <Option value={value._id} key={value._id}>{value.stringBuscar}</Option>
      ));
    }

    if (responses[1].data.status !== 404) {
      newState.todasProyectos = responses[1].data;
      newState.objetoProyectos = responses[1].data.map((value) => (
        <Option value={value._id} key={value._id}>{value.nombre}</Option>
      ));
    }

    if (responses[2]?.data?.success === 2) {
      newState.mostrarCostosRequisicion = responses[2].data.mostrarCostosRequisicion;
      newState.separarDiasRequisicion = responses[2].data.separarDiasRequisicion;
      newState.agregarInsumosRequisicion = responses[2].data.agregarInsumosRequisicion;
    }

    await this.promisedSetState(newState);

    let secondState = { loading: false };

    await axios
      .post(
        this.state.workbench ? "workbenchRequisiciones/datosWorkBench" : "requisiciones/datosRequisicion",
        {
          empresaId: this.props.empresaId,
          requisicionId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          // Si la requisición guardada tenía separarDias activo, restaurarlo
          const separarDiasGuardado = !!res.data.requisicion.separarDias;

          // El catálogo (`todasInsumos`) se aplica ANTES de escribir los
          // renglones: si no, cada SelectInsumosItem se monta sin
          // `insumoPreCargado` y dispara su propio POST a
          // selectInsumosItemCompraFuncion (eran ~N peticiones al abrir).
          await this.promisedSetState({
            proyectoId: res.data.requisicion.proyectoId,
            requisicionesAdicionales: res.data.requisicionesAdicionales,
            separarDiasActivo: separarDiasGuardado,
            todasInsumos: res.data.insumos || [],
          });

          this.formRef.current.setFieldsValue({
            ...res.data.requisicion,
            solicitanteId: res.data.requisicion.solicitanteId || res.data.requisicion.usuarioId,
            fechaEntrega: res.data.requisicion.fechaEntrega ? moment(res.data.requisicion.fechaEntrega) : null,
            fechaSolicitud: res.data.requisicion.fechaSolicitud ? moment(res.data.requisicion.fechaSolicitud) : null,
            insumos: res.data.requisicion.insumos ? res.data.requisicion.insumos.map(valueInsumo => ({
              ...valueInsumo,
              fechaEntrega: valueInsumo.fechaEntrega ? moment(valueInsumo.fechaEntrega) : null,
            })) : [],
          });

          if (res.data.requisicion.insumos && res.data.requisicion?.insumos?.length > 0) {

            const insumosReq = res.data.requisicion.insumos.map((valueInsumo, index) => {
              const insumo = res.data.insumos.find((i) => i._id === valueInsumo.insumoId);
              return {
                index,
                insumoId: valueInsumo.insumoId,
                inventariable: !!insumo?.inventariable,
                insumoCompuesto: !!insumo?.insumoCompuesto,
                noPrincipal: !!insumo?.noPrincipal,
              };
            });

            let inventariosMap = {};
            try {
              const bulkRes = await axios.post(
                "inventarios/inventarioInsumoProyectoBulk",
                {
                  proyectoId: this.state.proyectoId,
                  empresaId: this.props.empresaId,
                  pedidosSeleccionados: this.state.pedidosSeleccionados,
                  pedidoId: this.state.pedidoId,
                  ventaId: this.state.ventaId,
                  insumos: insumosReq,
                },
                { headers: this.props.headersToken }
              );
              bulkRes.data.results.forEach((r) => {
                inventariosMap[r.index] = r.tipo === "NO_INVENTARIABLE" ? "No inventariable" : r.cantidad;
              });
            } catch (error) {
              console.error("Error bulk inventario:", error);
            }

            let insumosConInventario = res.data.requisicion.insumos.map((it, idx) => ({
              ...it,
              inventario: inventariosMap[idx] ?? null,
              fechaEntrega: it.fechaEntrega ? moment(it.fechaEntrega) : null,
            }));

            this.formRef.current.setFieldsValue({ insumos: insumosConInventario });

            let objetoProveedoresPInsumos = res.data.requisicion.insumos.map(valueInsumo => {
              const insumo = res.data.insumos.find(
                (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
              );

              if (!insumo) return (
                <Option value={0} key={0} disabled>
                  Seleccione un insumo para ver sus proveedores
                </Option>
              );

              let objetoProveedores = [];

              if (insumo.relaciones && insumo.relaciones?.length > 0) {
                let keysProveedores = [];
                for (const relacion of insumo.relaciones) {
                  if (relacion.estado !== 0) {
                    const indexProv = keysProveedores.findIndex(valueKey => valueKey.toString() === relacion.proveedorId.toString());
                    if (indexProv === -1) keysProveedores.push(relacion.proveedorId.toString());
                  }
                }
                for (const proveedorId of keysProveedores) {
                  const proveedor = this.state.todasProveedores.find(
                    (valueProveedores) => valueProveedores._id.toString() === proveedorId.toString()
                  );
                  if (!proveedor) continue;
                  objetoProveedores.push(
                    <Option value={proveedor._id} key={proveedor._id}>{proveedor.stringBuscar}</Option>
                  );
                }
              }

              return objetoProveedores;
            });

            secondState.objetoProveedoresPInsumos = objetoProveedoresPInsumos;
          }

          secondState.numeroRequisicion = (res.data.requisicion?.serie ? (res.data.requisicion.serie + " ") : "") + res.data.requisicion.numero;
          secondState.presupuestoPU = res.data.requisicion.presupuestoPU;
          secondState.presupuestoPUId = res.data.requisicion.presupuestoPUId;
        } else {
          message.error("Error no se encontro informacion de la requisición");
        }
      });

    await this.promisedSetState(secondState);
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(valuesForm, isAutoSave = false) {
    // Si quedó un recálculo de días pendiente en el debounce, aplicarlo ANTES de
    // leer el formulario: si no, se guardaría una `cantidad` obsoleta.
    this.recalcularPendientes.flush();
    const values = this.formRef.current
      ? this.formRef.current.getFieldsValue()
      : valuesForm;

    if (!isAutoSave) {
      this.setState({ loading: true });
    }
    axios
      .post(
        this.state.workbench ? "workbenchRequisiciones/editarWorkBench" : "requisiciones/editarRequisicion",
        {
          ...values,
          requisicionId: this.props.location.state.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          if(isAutoSave){
              message.success("Progreso guardado automáticamente"); 
          }else{
            message.success("Se ha editado " + (this.state.workbench ? "el workbench: " : "la requisicion: "));
            this.formRef.current.resetFields();
            this.atras(res.data.codigo);
          }
        } else if (res.data.success === 1) {
          message.error("No se puede editar" + (this.state.workbench ? " el workbench" : " la requisicion") + ", intente de nuevo");
        } else {
          message.error("Hubo un error y no se pudo editar" + (this.state.workbench ? " el workbench" : " la requisicion"));
        }
      });
  }

  // Etiquetas de los 7 días (Vie..Jue) a partir del viernes de fechaEntrega.
  // Memoizado por fecha: antes se creaban 7 objetos moment por renglón y render.
  etiquetasDias(fechaEntrega) {
    const clave = fechaEntrega ? moment(fechaEntrega).valueOf() : null;
    if (this._etiquetasDiasClave !== clave) {
      this._etiquetasDiasClave = clave;
      this._etiquetasDias = DIAS_SEMANA.map((dia, idx) => ({
        ...dia,
        numero: clave ? moment(clave).add(idx, "days").format("DD") : null,
      }));
    }
    return this._etiquetasDias;
  }

  // Recalcula la cantidad total sumando los días
  recalcularCantidadPorDias(arrayValue, key) {
    const dias = arrayValue[key]?.cantidadPorDia || {};
    const total = DIAS_SEMANA.reduce((acc, dia) => acc + (Number(dias[dia.key]) || 0), 0);
    arrayValue[key].cantidad = total > 0 ? total : arrayValue[key].cantidad;
  }

  // Índice por _id de `todasInsumos`: evita pagar un .find() lineal por celda y
  // por render. Se reconstruye solo cuando cambia la referencia del arreglo.
  get insumosPorId() {
    if (this._fuenteInsumosPorId !== this.state.todasInsumos) {
      this._fuenteInsumosPorId = this.state.todasInsumos;
      this._insumosPorId = new Map(
        (this.state.todasInsumos || []).map((insumo) => [String(insumo._id), insumo])
      );
    }
    return this._insumosPorId;
  }

  // Índice por _id de `requisicionesAdicionales`, para los tags de origen.
  get requisicionesPorId() {
    if (this._fuenteRequisiciones !== this.state.requisicionesAdicionales) {
      this._fuenteRequisiciones = this.state.requisicionesAdicionales;
      this._requisicionesPorId = new Map(
        (this.state.requisicionesAdicionales || []).map((r) => [String(r._id), r])
      );
    }
    return this._requisicionesPorId;
  }

  // Escribe una sola fila de "insumos" dándole identidad nueva solo a esa fila
  // (las demás conservan su referencia), para que los shouldUpdate acotados por
  // fila puedan detectar el cambio. Mismo patrón que EditarOrdenDeCompra.
  // El .slice() no es cosmético: sin un arreglo nuevo, Form.List no re-renderiza
  // (su shouldUpdate interno es prevValue !== nextValue) y la tabla se congela.
  aplicarFila(key, arrayValue) {
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = { ...arrayValue[key] };
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }

  // Calcula costo, costoConImpuestos y proveedorId de una fila a partir del
  // insumo (sin red, síncrono) y devuelve las <Option> de proveedor.
  // Extraído de onChangeInsumo para poder recalcular sin encender el Spin.
  calcularCamposDerivados(insumo, fila) {
    let objetoProveedores = [];

    if (insumo.relaciones && insumo.relaciones?.length > 0) {
      let keysProveedores = [];
      for (const relacion of insumo.relaciones) {
        if (relacion.estado !== 0) {
          const indexProv = keysProveedores.findIndex(valueKey => valueKey.toString() === relacion.proveedorId.toString());
          if (indexProv === -1) keysProveedores.push(relacion.proveedorId.toString());
        }
      }
      for (const proveedorId of keysProveedores) {
        const proveedor = this.state.todasProveedores.find(
          (valueProveedores) => valueProveedores._id.toString() === proveedorId.toString()
        );
        if (!proveedor) continue;
        objetoProveedores.push(
          <Option value={proveedor._id} key={proveedor._id}>{proveedor.stringBuscar}</Option>
        );
      }
    }

    let costoInsumo;
    if (fila.proveedorId) {
      const encontrarRelacion = insumo.relaciones.find(value => value.proveedorId.toString() === fila.proveedorId.toString());
      if (!encontrarRelacion) {
        costoInsumo = insumo.costo;
      } else {
        costoInsumo = (encontrarRelacion.costo / (encontrarRelacion.conversion || 1)) || insumo.costo;
      }
    } else {
      costoInsumo = insumo.costo;
    }

    fila.costo = (costoInsumo * (fila.cantidad || 1)) || 0;

    let totalImpuestosPrecioSinImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      let totalImpuesto;
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = costoInsumo * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto = (costoInsumo + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto;
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = fila.cantidad;
        if (cantidad) {
          totalImpuesto = (fila.impuestos || 0) / fila.cantidad;
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0;
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto;
      return null;
    });

    fila.costoConImpuestos = round2Decimals(
      (costoInsumo + totalImpuestosPrecioSinImpuestos) * (fila.cantidad || 1)
    );

    if (!fila.proveedorId && insumo?.proveedorDefaultId) {
      const proveedor = this.state.todasProveedores.find(
        (valueProveedores) => valueProveedores._id.toString() === insumo.proveedorDefaultId.toString()
      );
      const encontrarRelacion = insumo.relaciones?.some(value => value.proveedorId.toString() === insumo.proveedorDefaultId.toString());
      if (encontrarRelacion) {
        fila.proveedorId = proveedor ? proveedor._id : undefined;
      }
    }

    return objetoProveedores;
  }

  // Recálculo síncrono de una fila: sin red y sin Spin. Es el camino del tecleo.
  recalcularFila(key, insumo) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    if (!arrayValue || !arrayValue[key] || !insumo) return;

    // Si el switch de días está activo, recalcular cantidad antes del costo
    if (this.state.separarDiasActivo) {
      this.recalcularCantidadPorDias(arrayValue, key);
    }

    const objetoProveedores = this.calcularCamposDerivados(insumo, arrayValue[key]);

    const objetoProveedoresPInsumos = [...this.state.objetoProveedoresPInsumos];
    objetoProveedoresPInsumos[key] = objetoProveedores;
    this.setState({ objetoProveedoresPInsumos });

    this.aplicarFila(key, arrayValue);
  }

  // Recalcula una fila a partir del insumo que ya tiene elegido. Para cambios de
  // cantidad o de proveedor, que no necesitan volver a consultar el inventario.
  recalcularFilaPorKey = (arrayKey) => {
    const fila = this.formRef.current?.getFieldValue(["insumos", arrayKey]);
    const insumo = this.insumosPorId.get(String(fila?.insumoId));
    if (insumo) this.recalcularFila(arrayKey, insumo);
  };

  async onChangeInsumo(value, key, insumoEncontrado, noConsultar) {
    let arrayValue = this.formRef.current.getFieldValue("insumos");
    if (!arrayValue || !arrayValue[key]) return;

    const insumoId = arrayValue[key].insumoId;
    let insumo;
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      this.setState((prev) =>
        prev.todasInsumos.some((i) => String(i._id) === String(insumo._id))
          ? null
          : { todasInsumos: [...prev.todasInsumos, insumo] }
      );
    } else {
      insumo = this.insumosPorId.get(String(insumoId));
    }
    if (!insumo) return;

    // El Spin solo se enciende cuando de verdad hay una consulta al servidor.
    if ((insumo.inventariable || insumo.insumoCompuesto) && !noConsultar) {
      this.setState({ loading: true });
      try {
        const res = await axios.post(
          "inventarios/inventarioInsumoProyecto",
          {
            proyectoId: this.state.proyectoId,
            insumoId: insumoId,
            noPrincipal: insumo.noPrincipal,
            insumoCompuesto: insumo.insumoCompuesto,
            empresaId: this.props.empresaId,
            pedidosSeleccionados: this.state.pedidosSeleccionados
          },
          { headers: this.props.headersToken }
        );
        arrayValue = this.formRef.current.getFieldValue("insumos");
        if (!arrayValue || !arrayValue[key]) return;
        arrayValue[key].inventario = res.data.cantidad;
      } finally {
        this.setState({ loading: false });
      }
    } else if (!noConsultar) {
      arrayValue[key].inventario = "No inventariable";
    }

    this.recalcularFila(key, insumo);
  }

  // Handler para cuando cambia la cantidad de un día específico.
  // Solo acumula la fila: el recálculo (caro) lo hace `recalcularPendientes`
  // con debounce, para no pagarlo en cada dígito tecleado.
  onChangeCantidadDia(arrayKey) {
    this.filasPendientes.add(arrayKey);
    this.recalcularPendientes();
  }

  // Recalcula en un solo golpe todas las filas de día tocadas desde el último
  // flush: una sola escritura al store en vez de una por dígito.
  filasPendientes = new Set();

  recalcularPendientes = debounce(() => {
    const claves = [...this.filasPendientes];
    this.filasPendientes.clear();
    if (!claves.length || !this.formRef.current) return;

    const arrayValue = this.formRef.current.getFieldValue("insumos");
    if (!arrayValue) return;

    const nuevoArray = arrayValue.slice();
    const objetoProveedoresPInsumos = [...this.state.objetoProveedoresPInsumos];
    let huboCambioDeProveedores = false;

    for (const key of claves) {
      if (!nuevoArray[key]) continue;
      const dias = nuevoArray[key].cantidadPorDia || {};
      const total = DIAS_SEMANA.reduce((acc, dia) => acc + (Number(dias[dia.key]) || 0), 0);
      // Identidad nueva solo para la fila tocada.
      nuevoArray[key] = { ...nuevoArray[key], cantidad: total };
      const insumo = this.insumosPorId.get(String(nuevoArray[key].insumoId));
      if (!insumo) continue;
      // calcularCamposDerivados muta la COPIA, no el objeto del store.
      objetoProveedoresPInsumos[key] = this.calcularCamposDerivados(insumo, nuevoArray[key]);
      huboCambioDeProveedores = true;
    }

    if (huboCambioDeProveedores) {
      this.setState({ objetoProveedoresPInsumos });
    }
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }, 300);

  asignarProveedor(key) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    const arrayValue = insumos[key];
    if (!arrayValue) return;
    if (!arrayValue.insumoId) {
      message.error("Selecciona un insumo primero");
      return;
    }
    this.setState({
      modalAsignarProveedor: true,
      modalAsignarProveedorInsumoId: arrayValue.insumoId,
      modalAsignarProveedorKey: key
    });
  }

  async cerrarAsignarProveedor(nuevoInsumo) {
    if (nuevoInsumo) {
      const todasInsumos = [...this.state.todasInsumos];
      const buscarInsumoIndex = todasInsumos.findIndex(i => i._id === nuevoInsumo._id);
      if (buscarInsumoIndex !== -1) {
        todasInsumos[buscarInsumoIndex] = nuevoInsumo;
      }
      await this.setState({ todasInsumos });
      this.onChangeInsumo(undefined, this.state.modalAsignarProveedorKey);
    }
    this.setState({
      modalAsignarProveedor: false,
      modalAsignarProveedorInsumoId: null,
      modalAsignarProveedorKey: null
    });
  }

  verRequisicionModal(id) {
    this.setState({ modalVerRequisicion: true, modalVerRequisicionId: id });
  }

  cerrarModalVerRequisicion() {
    this.setState({ modalVerRequisicion: false, modalVerRequisicionId: null });
  }

  abrirObservaciones(index) {
    const insumosForm = this.formRef.current.getFieldValue('insumos') || [];
    const insumoFila = insumosForm[index];

    const proveedorIdFila = insumoFila?.proveedorId;
    const proveedorActual = this.state.todasProveedores?.find(p => p._id === proveedorIdFila);
    const nombreProveedorActual = proveedorActual 
      ? (proveedorActual.persona ? proveedorActual.razonSocial : `${proveedorActual.nombre} ${proveedorActual.apellidoPaterno}`) 
      : 'Proveedor Desconocido';

    const insumoCat = this.state.todasInsumos?.find(i => i._id === insumoFila?.insumoId);
    const observacionesPasadas = insumoCat?.observacionesPasadasProv || [];

    this.setState({
      modalObservaciones: true,
      modalObservacionesIndex: index,
      modalObservacionesObservaciones: insumoFila?.observaciones,
      modalObservacionesObservacionesPasadas: observacionesPasadas,
      modalObservacionesObservacionesXml: insumoFila?.observacionesXml,
      proveedorIdActual: proveedorIdFila, 
      nombreProveedorActual: nombreProveedorActual
    });
  }

  cerrarObservaciones(value) {
    const indice = this.state.modalObservacionesIndex;
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[indice].observaciones = value;
    this.aplicarFila(indice, insumos);
    this.setState({
      modalObservaciones: false,
      modalObservacionesIndex: null,
      modalObservacionesObservaciones: null,
      modalObservacionesObservacionesPasadas: null,
      proveedorIdActual: null,
      nombreProveedorActual: null
    });
  }

  obtenerColorTagRequisicion = (importancia) => {
    switch (importancia) {
      case 3: return "red";
      case 2: return "orange";
      case 1: return "green";
      default: return "blue";
    }
  };

  getInsumosColumns(mostrarDias) {
  // Una sola lectura de window.innerWidth: cada acceso fuerza un reflow y antes
  // se leía doce veces por render.
  const chico = window.innerWidth < 1600;
  const cols = [
    { title: "#", width: "3%" },
    { title: "Clave", width: chico ? "16%" : "12%" },
    { title: "Insumo", width: chico ? "36%" : "22%"},
    { title: "Unidad", width: chico ? "12%" : "8%" },
    { title: "Entrega", width: chico ? "22%" : "15%" },
    { title: mostrarDias ? "Cant. Total" : "Cant.", width: chico ? "13%" : "10%" },
    { title: "Req.", width: chico ? "12%" : "8%" },
    { title: "Inv.", width: chico ? "12%" : "8%" },
    { title: "Ord.", width: chico ? "12%" : "8%" },
    { title: "Proveedor",  width: chico ? "32%" : "20%" },
  ];
  if (this.state.mostrarCostosRequisicion) {
    cols.push({ title: "Costo / Costo c/Imp.", width: chico ? "20%" : "15%"});
  }
  cols.push({ title: "Acción", width: chico ? "18%" : "13%"});
  return cols;
}

  // Propiedad de clase (no un arrow nuevo por render): así `tabsConfig` deja de
  // cambiar de identidad en cada pasada, y es el requisito para memoizar la fila.
  renderInsumoRow = ({ key, name, fieldKey: _fieldKey, restField, arrayKey, remove }) => {
    const mostrarCostosRequisicion = this.state.mostrarCostosRequisicion;
    const mostrarDias = this.state.separarDiasRequisicion && this.state.separarDiasActivo;
    const totalCols              = mostrarCostosRequisicion ? 10 : 9;

    // Comparadores de shouldUpdate acotados a este renglón. Sin ellos, cada celda
    // se re-renderiza ante CUALQUIER cambio de CUALQUIER campo del formulario
    // (shouldUpdate booleano = reRender incondicional en rc-field-form).
    // Dependen de que aplicarFila() le dé identidad nueva solo a la fila tocada.
    const cambiaLaFila = (p, c) => p.insumos?.[arrayKey] !== c.insumos?.[arrayKey];
    const cambiaCantidadPorDia = (p, c) =>
      p.insumos?.[arrayKey]?.cantidadPorDia !== c.insumos?.[arrayKey]?.cantidadPorDia;

    return (
      <React.Fragment key={key}>
        {/* El <tr> entero depende de la fila completa (estado, origenes, costos),
            pero SOLO de esta fila: antes era un shouldUpdate desnudo y cualquier
            tecla en cualquier celda re-creaba el JSX de todos los renglones. */}
        <FormItem noStyle shouldUpdate={cambiaLaFila}>
          {({ getFieldValue }) => {
            const insumos = getFieldValue("insumos") || [];
            const insumo  = insumos[arrayKey];
            const insumoSeleccionado = this.insumosPorId.get(String(insumo?.insumoId));
            const origenesRequisicion = Array.isArray(insumo?.requisicionesOrigen) && insumo.requisicionesOrigen.length > 0
              ? insumo.requisicionesOrigen
              : (insumo?.requisicionId ? [{ requisicionId: insumo.requisicionId, cantidad: insumo?.cantidad }] : []);
            const tagsRequisicion = origenesRequisicion
              .map(origen => this.requisicionesPorId.get(String(origen.requisicionId)))
              .filter(Boolean)
              .map(req => ({ id: req._id, nombre: req.numero, fechaSolicitud: req.fechaSolicitud, importancia: req.importancia }));
            const bloqueado = (insumo?.estado && insumo?.estado !== 1) || this.state.presupuestoPU;
            return (
              <tr
                id={`insumo-row-${arrayKey}`}
                style={
                  this.state.insumoResaltado === arrayKey
                    ? { backgroundColor: "#fffbe6", outline: "2px solid #faad14", transition: "all 0.3s" }
                    : {}
                }
              >
                {/* No. */}
                <td className="td-border">
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {arrayKey + 1}
                  </div>
                </td>
                {/* Clave — se lee de `insumoSeleccionado`, ya resuelto arriba:
                    no hace falta otro Field anidado que vuelva a leer el store. */}
                <td className="td-border">
                  <div
                    style={{ fontSize: '14px', textAlign: 'center', color: '#868585', cursor: 'pointer' }}
                    onDoubleClick={() => {
                      const idParaDisponibilidad = insumoSeleccionado?.insumoPrincipalId || insumoSeleccionado?._id;
                      this.abrirDisponibilidad(idParaDisponibilidad, insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || '', this.state.proyectoId);
                    }}
                  >
                    {insumoSeleccionado?.clave || '-'}
                  </div>
                </td>
                {/* Insumo */}
                <td className="td-border">
                  <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                    <SelectInsumosItem
                      className="select-insumo-wrap"
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Insumo"
                      tiposInsumos="compra"
                      ocultarCodigoYUnidad
                      /* Evita que cada renglón dispare su propio POST a
                         selectInsumosItemCompraFuncion al montarse. */
                      insumoPreCargado={insumoSeleccionado}
                      onChange={(value, ins) => this.onChangeInsumo(value, arrayKey, ins)}
                      disabled={(insumo?.estado && insumo?.estado !== 1) || this.state.presupuestoPU}
                    />
                  </FormItem>
                </td>
                <td className="td-border">
                  <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                    {insumoSeleccionado?.unidad || '-'}
                  </div>
                </td>

                {/* Entrega */}
                <td className="td-border">
                  <FormItem {...restField} name={[name, "fechaEntrega"]} noStyle>
                    <DatePickerItem placeholder="Fecha de Entrega" />
                  </FormItem>
                </td>
                {/* Cantidad */}
                <td className="td-border">
                  <FormItem {...restField} name={[name, "cantidad"]} required number noStyle>
                    <InputNumberItem
                      sinBorde
                      placeholder="Cantidad"
                      disabled={mostrarDias || (bloqueado && !this.state.workbench)}
                      onChange={
                        !mostrarDias
                          ? () => this.recalcularFilaPorKey(arrayKey)
                          : undefined
                      }
                    />
                  </FormItem>
                </td>
                {/* Req. */}
                <td className="td-border" style={{ textAlign: "center" }}>
                  {tagsRequisicion.length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                      {tagsRequisicion.map(t => (
                        <Tooltip key={t.id} title={"Fecha de solicitud: " + (t.fechaSolicitud ? moment(t.fechaSolicitud).format("DD/MM/YYYY") : "")}>
                          <Tag color={this.obtenerColorTagRequisicion(t.importancia)} onClick={() => this.verRequisicionModal(t.id)}>
                            {"Req. " + t.nombre}
                          </Tag>
                        </Tooltip>
                      ))}
                    </div>
                  ) : null}
                </td>
                {/* Inventario */}
                <td className="td-border">
                  <FormItem {...restField} name={[name, "inventario"]} noStyle>
                    <InputNumberItem sinBorde disabled placeholder="Inventario" />
                  </FormItem>
                </td>
                {/* Ord. */}
                <td className="td-border">
                  <FormItem {...restField} name={[name, "cantidadOrdenada"]} noStyle>
                    <InputNumberItem sinBorde placeholder="Cantidad Ordenada" disabled />
                  </FormItem>
                </td>
                {/* Proveedor */}
                <td className="td-border">
                  <FormItem {...restField} name={[name, "proveedorId"]} margin noStyle>
                    <SelectItem
                      sinBorde
                      style={{ width: "100%" }}
                      placeholder="Proveedor"
                      disabled={insumo?.estado && insumo?.estado !== 1}
                      onChange={() => this.recalcularFilaPorKey(arrayKey)}
                    >
                      {this.state.objetoProveedoresPInsumos[arrayKey]}
                    </SelectItem>
                  </FormItem>
                </td>
                {mostrarCostosRequisicion ? (
                  <td className="td-border">
                    <div className="celda-totales" style={{ fontSize: "12px" }}>
                      <div>{dineroDisabledMask(insumo?.costo || 0)}</div>
                      <div className="total-bold">c/Imp: {dineroDisabledMask(insumo?.costoConImpuestos || 0)}</div>
                    </div>
                    <FormItem {...restField} name={[name, "costo"]}            hidden><InputNumberItem /></FormItem>
                    <FormItem {...restField} name={[name, "costoConImpuestos"]} hidden><InputNumberItem /></FormItem>
                  </td>
                ) : null}
                <td className="td-border-sin-right">
                <Row className="acciones-container">
                  <Col span={24}>
                    <Space
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                      size={0}
                      className="acciones-container"
                    >
                                          
                      <Space size={0}>
                        <Tooltip
                          title="Asignar Proveedor"
                          placement="top"
                          overlayInnerStyle={{ fontSize: "10px" }}
                        >
                          <ButtonItem
                            type="link"
                            onClick={() => this.asignarProveedor(arrayKey)}
                            icon={<UserOutlined />}
                          ></ButtonItem>
                        </Tooltip>

                        {/* `insumo` ya viene resuelto del wrapper de la fila:
                            no hace falta un Field anidado que relea el store. */}
                        {insumo?.insumoId && this.state.todasInsumos ? (
                          <Tooltip
                            key="obs-tooltip"
                            title="Agregar Observaciones"
                            placement="top"
                            overlayInnerStyle={{fontSize: "10px" }}
                          >
                            <ButtonItem
                              type="primary"
                              size="small"
                              cyan2
                              icon={<CommentOutlined />}
                              verde={insumo?.observaciones}
                              onClick={() =>
                                this.abrirObservaciones(arrayKey)
                              }
                            />
                          </Tooltip>
                        ) : null}
                      </Space>

                      {!(bloqueado && !this.state.workbench) ? (
                        <Tooltip
                          title="Eliminar"
                          placement="top"
                          overlayInnerStyle={{ fontSize: "10px"}}
                        >
                          <ButtonItem
                            rojo2
                            icon={<DeleteOutlined />}
                            onClick={() => remove(name)}
                            size="small"
                          />
                        </Tooltip>
                      ) : null}

                    </Space>
                  </Col>
                </Row>
              </td>
                
              </tr>
            );
          }}
        </FormItem>

        {mostrarDias && (
          <tr>
            <td
              colSpan={totalCols}
              className="td-border"
              style={{ padding: "6px 8px", backgroundColor: "#fafafa" }}
            >
              <FormItem noStyle shouldUpdate={(p, c) => p.fechaEntrega !== c.fechaEntrega}>
                {({ getFieldValue }) => {
                  // Las 7 fechas se calculan una sola vez por fechaEntrega y se
                  // comparten entre todos los renglones (antes eran 7 objetos
                  // moment nuevos por renglón y por render).
                  const etiquetasDias = this.etiquetasDias(getFieldValue("fechaEntrega"));
                  return (
              <div style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
                <span style={{ fontSize: 12, color: "#666", marginRight: 4, whiteSpace: "nowrap" }}>
                  Cant. por día:
                </span>
                {etiquetasDias.map((dia) => (
                  <div
                    key={dia.key}
                    style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 60 }}
                  >
                    <span style={{ fontSize: 11, fontWeight: 600, color: "#1890ff", marginBottom: 2, lineHeight: 1 }}>
                      {dia.label}
                      {dia.numero && (
                        <span style={{ fontWeight: 400, color: "#888", marginLeft: 3 }}>
                          {dia.numero}
                        </span>
                      )}
                    </span>
                    <FormItem {...restField} name={[name, "cantidadPorDia", dia.key]} noStyle>
                      <InputNumberItem
                        sinBorde
                        placeholder="0"
                        style={{ width: 60, textAlign: "center", border: "1px solid #d9d9d9", borderRadius: 4, fontSize: 12 }}
                        min={0}
                        onChange={() => this.onChangeCantidadDia(arrayKey)}
                        onBlur={() => this.recalcularPendientes.flush()}
                      />
                    </FormItem>
                  </div>
                ))}
                <FormItem noStyle shouldUpdate={cambiaCantidadPorDia}>
                  {({ getFieldValue }) => {
                    const insumos = getFieldValue("insumos") || [];
                    const dias  = insumos[arrayKey]?.cantidadPorDia || {};
                    const total = DIAS_SEMANA.reduce((acc, dia) => acc + (Number(dias[dia.key]) || 0), 0);
                    return (
                      <div
                        style={{
                          display: "flex", flexDirection: "column", alignItems: "center",
                          marginLeft: 8, padding: "2px 10px",
                          background: total > 0 ? "#e6f7ff" : "#f5f5f5",
                          border: `1px solid ${total > 0 ? "#91d5ff" : "#d9d9d9"}`,
                          borderRadius: 4, minWidth: 60,
                        }}
                      >
                        <span style={{ fontSize: 11, color: "#666", lineHeight: 1, marginBottom: 2 }}>Total</span>
                        <span style={{ fontSize: 14, fontWeight: 700, color: total > 0 ? "#1890ff" : "#bfbfbf" }}>{total}</span>
                      </div>
                    );
                  }}
                </FormItem>
              </div>
                  );
                }}
              </FormItem>
            </td>
          </tr>
        )}

        {/* Fila de observaciones */}
        <FormItem
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.insumos?.[arrayKey]?.observaciones !== curr.insumos?.[arrayKey]?.observaciones
          }
        >
          {({ getFieldValue }) => {
            const arrayValue = getFieldValue("insumos") || [];
            if (arrayValue[arrayKey]?.observaciones) {
              return (
                <tr>
                  <td colSpan="10" className="td-border-sin-right">
                    <div style={{ display: "flex", justifyContent: "left", alignItems: "left", backgroundColor: "white" }}>
                      <div style={{ width: "90%", textAlign: "left", paddingLeft: 20 }}>
                        {String(arrayValue[arrayKey].observaciones)
                          .split(/\r?\n/)
                          .map((line, i) => (
                            <span key={i}>{line}<br /></span>
                          ))}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
            return null;
          }}
        </FormItem>
      </React.Fragment>
    );
  };

  getObservacionesConfig() {
    return {
      totales: (
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos !== curr.insumos}>
          {({ getFieldValue }) => {
            const insumos      = getFieldValue("insumos") || [];
            const totalCosto    = insumos.reduce((acc, it) => acc + (Number(it?.costo)            || 0), 0);
            const totalCostoImp = insumos.reduce((acc, it) => acc + (Number(it?.costoConImpuestos) || 0), 0);
            return (
              <table className="table" style={{ borderCollapse: "collapse", width: "100%", margin: 0 }}>
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ width: "50%" }}>Total Costo: </th>
                    <td className="td-totales-right">{dineroDisabledMask(totalCosto)}</td>
                  </tr>
                  <tr>
                    <th className="th-totales" style={{ width: "50%" }}>Total con Impuestos:</th>
                    <td className="td-totales-right">{dineroDisabledMask(totalCostoImp)}</td>
                  </tr>
                </tbody>
              </table>
            );
          }}
        </FormItem>
      ),
    };
  }

  renderProyectoCard() {
    return (
      <FormItem noStyle shouldUpdate={(p, c) => p.proyectoId !== c.proyectoId}>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          if (!proyectoId) return null;
          const proyecto = this.state.todasProyectos?.find((value) => value._id === proyectoId);
          if (!proyecto) return null;
          return (
            <Row>
              <InfoCard
                title="PROYECTO"
                icon={<InfoCircleOutlined />}
                accentColor="#00BFD6"
                compact
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 8,
                    items: [
                      { label: "Nombre",      value: proyecto.nombre      || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 8,
                    items: proyecto.calle
                      ? [{ label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` }]
                      : [
                          { label: "Marca",  value: proyecto.marca  || "-" },
                          { label: "Modelo", value: proyecto.modelo || "-" },
                          { label: "Placas", value: proyecto.placas || "-" },
                        ],
                  },
                  {
                    title: "Detalles",
                    icon: <CarOutlined />,
                    iconColor: "#FF6A0D",
                    lg: 8,
                    items: [
                      { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                      { label: "ID",   value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                    ],
                  },
                ]}
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  buscarInsumo = (valor) => {
    this.setState({ busquedaInsumo: valor, insumoResaltado: null });
    if (!valor) return;

    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    const index = insumos.findIndex((insumo) => {
      const infoInsumo = this.state.todasInsumos.find(
        (i) => i._id === insumo.insumoId
      );
      if (!infoInsumo) return false;
      return (
        infoInsumo.descripcion?.toLowerCase().includes(texto) ||
        infoInsumo.codigo?.toLowerCase().includes(texto) ||
        infoInsumo.clave?.toLowerCase().includes(texto) ||
        infoInsumo.codigoBarras?.toLowerCase().includes(texto)
      );
    });

    if (index === -1) {
      message.warning("No se encontró ningún insumo con ese criterio");
      return;
    }

    this.setState({ insumoResaltado: index });

    const fila = document.getElementById(`insumo-row-${index}`);
    if (fila) {
      fila.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  cerrarModalCrearInsumo = (insumoId, nuevoInsumo) => {
    if (insumoId && this.addInsumoRef) {
      this.autoGuardarYAgregar(this.addInsumoRef).then(() => {
        setTimeout(() => {
          const insumos = this.formRef.current.getFieldValue('insumos') || [];
          const newIdx = insumos.length - 1;
          const currentInsumos = [...insumos];
          currentInsumos[newIdx] = { ...currentInsumos[newIdx], insumoId };
          this.formRef.current.setFieldsValue({ insumos: currentInsumos });
          this.onChangeInsumo(insumoId, newIdx, nuevoInsumo);
        }, 100);
      });
    }
    this.setState({ modalCrearInsumo: false });
  }

  autoGuardarYAgregar = async (add) => {
    // El switch de auto-guardado ahora se respeta. Antes se guardaba SIEMPRE:
    // cada clic en "Agregar Insumo" validaba las N filas y subía el documento
    // completo, que es de donde venía buena parte del congelamiento.
    if (!this.state.autoGuardarActivo) {
      add();
      return;
    }
    this.recalcularPendientes.flush();
    try {
      // Validar campos antes de guardar
      await this.formRef.current.validateFields();
      const valoresActuales = this.formRef.current.getFieldsValue();

      this.onFinish(valoresActuales, true);
    } catch (errorInfo) {
      message.warning("No se pudo completar el auto guardado.");
    }
    add();
  };

  render() {
    const {
      separarDiasRequisicion, // config empresa: muestra el switch
      separarDiasActivo,      // switch del formulario: activa la fila de días
      mostrarCostosRequisicion,
      agregarInsumosRequisicion
    } = this.state;

    // Las filas de días se muestran solo si AMBAS condiciones son true
    const mostrarDias = separarDiasRequisicion && separarDiasActivo;
    const isMobile = false;

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Editar " + (this.state.workbench ? "Workbench #" : " Requisicion #") + this.state.numeroRequisicion}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra = {[
            <Space key="auto-save-space" align="center">
                <span style={{ fontWeight: '500', color: this.state.autoGuardarActivo ? '#52c41a' : 'gray' }}>
                    Auto-guardado {this.state.autoGuardarActivo ? 'Activado' : 'Desactivado'}
                </span>
                <SwitchItem 
                    checked={this.state.autoGuardarActivo} 
                    onChange={(checked) => this.setState({ autoGuardarActivo: checked })} 
                />
            </Space>
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarRequisicion"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <GeneralFormLayout
                isMobile={isMobile}
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 12,
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col span={24}>
                          <FormItem label="Fecha Solicitud" name="fechaSolicitud" margin labelCol={{ span: 6 }} wrapperCol={{ span: 17 }}>
                            <DatePickerItem placeholder="Fecha de Solicitud" />
                          </FormItem>
                          <FormItem label="Fecha Entrega" name="fechaEntrega" margin labelCol={{ span: 6 }} wrapperCol={{ span: 17 }}>
                            <DatePickerItem
                              placeholder="Fecha de Entrega"
                              disabledDate={
                                separarDiasActivo
                                  ? (current) => current && current.day() !== 5
                                  : undefined
                              }
                            />
                          </FormItem>
                          <FormItem
                            label="Solicitante"
                            name="solicitanteId"
                            tooltip="Usuario que solicita la requisición, si no se selecciona, se asigna al usuario que crea la requisición por defecto."
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 17 }}
                          >
                            <SelectItem disabled placeholder="Seleeccione a quién se le asignará la requisición">
                              {this.state.objetoUsuarios}
                            </SelectItem>
                          </FormItem>
                          <FormItem label="Proyecto" name="proyectoId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 17 }}>
                            <SelectItem disabled={this.state.presupuestoPU} placeholder="Proyecto">
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Extras",
                    lg: 12,
                    content: (
                      <>
                        <FormItem
                          label="Separar Ins:"
                          name="separarInsumos"
                          margin
                          initialValue={false}
                          valuePropName="checked"
                          tooltip="¿Esto indicara al momento de recibir la orden de compra, que se separen los insumos?"
                           labelCol={{ span: 5 }}
                          wrapperCol={{ span: 19 }}
                        >
                          <SwitchItem />
                        </FormItem>
                        <FormItem
                          label="Importancia"
                          name="importancia"
                          tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta"
                          margin
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 5 }}
                        >
                          <SelectItem placeholder="Seleccione nivel" style={{ width: "100%" }}>
                            <Option value={1}>
                              <Tag color="green" style={{ marginRight: 8 }}><ArrowUpOutlined /> Baja</Tag>
                            </Option>
                            <Option value={2}>
                              <Tag color="orange" style={{ marginRight: 8 }}><WarningOutlined /> Media</Tag>
                            </Option>
                            <Option value={3}>
                              <Tag color="red" style={{ marginRight: 8 }}><FireOutlined /> Alta</Tag>
                            </Option>
                          </SelectItem>
                        </FormItem>
                        {separarDiasRequisicion && (
                          <FormItem
                            label="Sep. Días:"
                            name="separarDias"
                            margin
                            valuePropName="checked"
                            tooltip="Activar para registrar la cantidad por día de la semana en cada insumo."
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 21 }}
                          >
                            <SwitchItem
                              onChange={(checked) => {
                                if (checked) {
                                  const fechaEntrega = this.formRef.current.getFieldValue("fechaEntrega");
                                  if (!fechaEntrega) {
                                    message.error("Selecciona la fecha de entrega antes de separar por días");
                                    this.formRef.current.setFieldsValue({ separarDias: false });
                                    return;
                                  }
                                  if (moment(fechaEntrega).day() !== 5) {
                                    message.error("La fecha de entrega debe ser un viernes para separar por días");
                                    this.formRef.current.setFieldsValue({ separarDias: false });
                                    return;
                                  }
                                }
                                this.setState({ separarDiasActivo: checked });
                                if (!checked) {
                                  const insumos = this.formRef.current.getFieldValue("insumos") || [];
                                  const insumosLimpiados = insumos.map(ins => ({
                                    ...ins,
                                    cantidadPorDia: {},
                                    cantidad: null,
                                  }));
                                  this.formRef.current.setFieldsValue({ insumos: insumosLimpiados });
                                }
                              }}
                            />
                          </FormItem>
                        )}
                        {this.state.workbench && (
                          <FormItem
                            label="Prov."
                            name="proveedorId"
                            margin
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 21 }}
                          >
                            <SelectProveedoresItem
                              empresaId={this.props.empresaId}
                              headersToken={this.props.headersToken}
                              sinBorde
                              autoFocus
                              dropdownMatchSelectWidth={600}
                              width="100%"
                              placeholder="Proveedor"
                            />
                          </FormItem>
                        )}
                        <FormItem
                          label="Obsr."
                          name="observaciones"
                          margin
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 21 }}
                          pattern
                        >
                          <TextAreaItem placeholder="Observaciones" />
                        </FormItem>
                      </>
                    ),
                  },
                ]}
              />

              {/* ── InfoCard del proyecto seleccionado ── */}
              <div style={{ padding: "0 16px", marginBottom: 16 }}>
                {this.renderProyectoCard()}
              </div>

              {/* ── Tabla de insumos + totales + botones ── */}
              <GeneralFormLayout
              totalesMaxWidth="35%"
                isMobile={isMobile}
                tabsConfig={{
                  tableClassName: "tabla-insumos-venta requisiciones-celdas-amplias",
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(mostrarDias),
                      renderRow: this.renderInsumoRow,
                      renderHeader: () => (
                     <Row justify="end" style={{ marginBottom: 8 }} gutter={8}>
                          <Col span={10}>
                            <Input.Search
                              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                              placeholder="Buscar por descripción, código, clave o cód. barras..."
                              allowClear
                              enterButton={
                                <Button
                                  type="primary"
                                  style={{
                                    background: "#00BFD6",
                                    borderColor: "#00BFD6"
                                  }}
                                >
                                  Buscar
                                </Button>
                              }
                              size="middle"
                              onSearch={this.buscarInsumo}
                              onChange={(e) => {
                                if (!e.target.value) this.setState({ insumoResaltado: null });
                              }}
                              style={{ borderRadius: 8, paddingRight: 18 }}
                            />
                          </Col>
                        </Row>
                      ),
                      renderFooter: ({ add, fields }) => {
                        this.addInsumoRef = add;
                        return (
                        <FormItem noStyle>
                          <Space style={{ marginTop: 10, marginBottom: 10 }}>
                          <Tooltip title={this.state.workbench ? "No se recomienda agregar insumos directamente en el workbench" : "Agregar Insumo"}>
                            <ButtonItem
                              type="primary"
                              onClick={() => {
                                if (this.state.workbench) {
                                  message.warning("No se recomienda agregar insumos directamente en el workbench");
                                }
                                this.autoGuardarYAgregar(add);
                              }}
                              disabled={this.state.presupuestoPU}
                              hotkey="alt+a"
                              icon={<PlusOutlined />}
                              cyan
                            >
                              Agregar Insumo
                            </ButtonItem>
                          </Tooltip>
                          {agregarInsumosRequisicion && (
                            <ButtonItem
                              disabled={this.state.presupuestoPU}
                              onClick={() => this.setState({ modalCrearInsumo: true })}
                              icon={<PlusOutlined />}
                              cyan
                            >
                              Crear Insumo
                            </ButtonItem>
                          )}
                          </Space>
                        </FormItem>
                        );
                      },
                    },
                  ],
                }}
                observacionesConfig={mostrarCostosRequisicion ? this.getObservacionesConfig() : undefined}
                actionButtons={
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <ButtonItem
                      type="primary"
                      cyanB
                      style={{ display: "inline-block" }}
                      onClick={() => this.abrirModalVerPdf()}
                    >
                      Ver Requisicion
                    </ButtonItem>
                     <ButtonItem type="primary" azulMB htmlType="submit"  hotkey="shift+E" style={{ display: "inline-block" }}>
                      Editar
                    </ButtonItem>
                  </div>
                }
              />
            </Form>
          </Spin>
        </div>
        <ModalAgregarInsumoRequisicion
          visible={this.state.modalCrearInsumo}
          cerrar={this.cerrarModalCrearInsumo}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          lotesCaducidades={this.props.lotesCaducidades}
        />
        <VerRequisicionPdf
          visible={this.state.modalVerPdf}
          requisicionId={this.state.modalVerPdfId}
          onCancel={this.cerrarModalVerPdf.bind(this)}
          cerrarModalVerPdf={this.cerrarModalVerPdf.bind(this)}
        />
        <AsignarProveedor
          insumoId={this.state.modalAsignarProveedorInsumoId}
          visible={this.state.modalAsignarProveedor}
          cerrarAsignarProveedor={this.cerrarAsignarProveedor.bind(this)}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />
        <ModalVerRequisicion
          visible={this.state.modalVerRequisicion}
          requisicionId={this.state.modalVerRequisicionId}
          onClose={this.cerrarModalVerRequisicion.bind(this)}
          cerrarModalVerRequisicion={this.cerrarModalVerRequisicion.bind(this)}
        />
        <ElegirObservaciones
          visible={this.state.modalObservaciones}
          cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
          observaciones={this.state.modalObservacionesObservaciones}
          observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
          observacionesXml={this.state.modalObservacionesObservacionesXml}
          noXml
        />
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarRequisicion);